import styled from 'styled-components';
import photo1 from 'assets/images/photo-1.jpg';
import photo2 from 'assets/images/photo-2.jpg';
import photo3 from 'assets/images/photo-3.jpg';
import photo4 from 'assets/images/photo-4.jpg';
import photo5 from 'assets/images/photo-5.jpg';
import photoGrid1 from 'assets/images/photo-grid-1.jpg';
import photoGrid2 from 'assets/images/photo-grid-2.jpg';
import photoGrid3 from 'assets/images/photo-grid-3.jpg';
import photoGrid4 from 'assets/images/photo-grid-4.jpg';
import { fonts } from 'styles';

export const Container = styled.main`
  width: 100%;
  margin: 0 auto;
`;

export const Content = styled.section`
  width: 100%;
  margin: 0 auto;
  padding: 72px 40px;

  &.first {
    padding-top: 96px;
  }

  @media screen and (max-width: 500px) {
    &.first {
      padding-top: 56px;
    }
    padding: 56px 40px;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 26px;
  color: #111111;

  .drop-caps:first-letter {
    font-size: 4em;
    float: left;
    padding: 0 10px 0 0;
    font-family: ${fonts.BentonSansWideBlack};
    line-height: 1em;
  }
  p {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ImageWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: max-content;
  display: flex;
  column-gap: 8px;
  row-gap: 8px;
  flex-wrap: wrap;
`;

export const Photo1 = styled.img.attrs({ src: photo1 })`
  width: 100%;
  max-width: max-content;
`;

export const Photo2 = styled.img.attrs({ src: photo2 })`
  width: 100%;
  max-width: max-content;
`;

export const Photo3 = styled.img.attrs({ src: photo3 })`
  width: 100%;
  max-width: max-content;
`;

export const Photo4 = styled.img.attrs({ src: photo4 })`
  width: 100%;
  max-width: max-content;
`;

export const Photo5 = styled.img.attrs({ src: photo5 })`
  width: 100%;
  max-width: max-content;
`;

export const PhotoGrid = styled.div`
  width: 100%;
  max-width: max-content;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4px;
  margin: 0 auto;

  @media screen and (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const PhotoGrid1 = styled.img.attrs({ src: photoGrid1 })`
  width: 100%;
  max-width: max-content;
`;

export const PhotoGrid2 = styled.img.attrs({ src: photoGrid2 })`
  width: 100%;
  max-width: max-content;
`;

export const PhotoGrid3 = styled.img.attrs({ src: photoGrid3 })`
  width: 100%;
  max-width: max-content;
`;

export const PhotoGrid4 = styled.img.attrs({ src: photoGrid4 })`
  width: 100%;
  max-width: max-content;
`;

export const PhotoLegend = styled.div`
  font-family: ${fonts.BentonSansRegular};
  font-size: 14px;
  line-height: 26px;
  margin-top: 24px;
  text-align: center;
  padding: 0 40px;
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  padding: 56px 40px;
  position: relative;

  ::before {
    content: '';
    display: block;
    width: 76px;
    height: 5px;
    background-color: #111;
    position: absolute;
    top: 0;
  }
`;
